import axios from "axios";
import { globalAction } from "redux-subspace";

import { HttpCodes } from "./constants";

const REGISTER = "REGISTER";
const SET_ERROR_MSG = "SET_ERROR_MSG";

export default function registerReducer(
  state = {
    status: 0,
    error: "",
    username: "",
  },
  action
) {
  switch (action.type) {
    case REGISTER:
      return {
        status: action.data.status,
        error: action.data.message,
        username: action.data.username,
      };
    case SET_ERROR_MSG:
      return {
        ...state,
        error: "",
        status: 0,
      };
    default: {
      return state;
    }
  }
}

export const resetErrorMsg = () => (dispatch) => {
  return dispatch({
    type: SET_ERROR_MSG,
  });
};

export const register = (participant) => async (dispatch) => {
  const username = participant.email;
  try {
    await axios.post(`/api/account/registration`, participant);
  } catch (e) {
    const status = e.response.status;
    let message = "";
    if (status !== HttpCodes.OK && status !== HttpCodes.INTERNAL_ERROR) {
      if (e.response.data && e.response.data.ExceptionMessage) {
        message = e.response.data.ExceptionMessage;
      } else if (status === HttpCodes.CONFLICT) {
        if (e.response.data) {
          message = e.response.data;
        } else {
          message = "Username already exists.";
        }
      } else {
        message = "Internal Error";
      }
    } else {
      message = "Internal Error";
    }

    dispatch(
      globalAction({
        type: REGISTER,
        data: {
          status,
          message,
          username,
        },
      })
    );
    return Promise.reject(message);
  }

  dispatch({
    type: REGISTER,
    data: {
      status: HttpCodes.OK,
      message: "",
      username: username,
    },
  });
  return Promise.resolve();
};

export const mapStateToPropsRegister = (state) => {
  const { status, error, username } = state.registerReducer;
  return { status, error, username };
};

export const mapDispatchToPropsRegister = { register, resetErrorMsg };
